import {
  Home,
  Wrench,
  Bell,
  Wifi,
  Activity,
  HardDriveDownload,
  MonitorCheck,
} from "lucide-react";

// Single source of truth for dashboard sections.
// `key` must match src backend modules (dashboard-backend/src/modules.js).
export const MODULES = [
  { key: "home", label: "Home", path: "/dashboard", icon: Home, desc: "Overview, birthdays and holidays" },
  { key: "tools", label: "Tools", path: "/dashboard/tools", icon: Wrench, desc: "Links to company applications" },
  { key: "announcements", label: "Announcements", path: "/dashboard/announcements", icon: Bell, desc: "Company and IT notices" },
  { key: "wifi", label: "WiFi Passwords", path: "/dashboard/wifi", icon: Wifi, desc: "Office network credentials" },
  { key: "cadence", label: "Cadence License", path: "/dashboard/cadence-license", icon: Activity, desc: "Live licence usage (design team)" },
  { key: "backup", label: "Backup Monitor", path: "/dashboard/backup", icon: HardDriveDownload, desc: "NAS backup status per cycle" },
  { key: "software", label: "Software Monitor", path: "/dashboard/software", icon: MonitorCheck, desc: "Tool inventory, uptime and renewals" },
];

export const ADMIN_NAV = { label: "User Management", path: "/dashboard/admin/users" };

export const allowedModules = (user) =>
  MODULES.filter((m) => user && (user.role === "admin" || user.modules.includes(m.key)));

export const firstAllowedPath = (user) => allowedModules(user)[0]?.path || "/dashboard/profile";
